export default {
  TuvaDataTools: {
    ESCAPE: {
      osx: 'command+esc',
      windows: 'ctrl+esc',
      linux: 'ctrl+esc',
      other: 'ctrl+esc'
    },
    RESET: {
      osx: 'command+r',
      windows: 'ctrl+r',
      linux: 'ctrl+r',
      other: 'ctrl+r'
    },
    UNDO: {
      osx: 'command+z',
      windows: 'ctrl+z',
      linux: 'ctrl+z',
      other: 'ctrl+z'
    },
    REDO: {
      osx: 'command+y',
      windows: 'ctrl+y',
      linux: 'ctrl+y',
      other: 'ctrl+y'
    },
    COPY: {
      osx: 'command+c',
      windows: 'ctrl+c',
      linux: 'ctrl+c',
      other: 'ctrl+c'
    },
    PASTE: {
      osx: 'command+v',
      windows: 'ctrl+v',
      linux: 'ctrl+v',
      other: 'ctrl+v'
    },
    EXCLUDE_SELECTED: {
      osx: 'command+e',
      windows: 'ctrl+e',
      linux: 'ctrl+e',
      other: 'ctrl+e'
    },
    KEEP_SELECTED: {
      osx: 'command+k',
      windows: 'ctrl+k',
      linux: 'ctrl+k',
      other: 'ctrl+k'
    },
    RESET_FILTER: {
      osx: 'command+f',
      windows: 'ctrl+f',
      linux: 'ctrl+f',
      other: 'ctrl+f'
    },
    SCREENSHOT: {
      osx: 'command+s',
      windows: 'ctrl+s',
      linux: 'ctrl+s',
      other: 'ctrl+s',
    },
    KEYBOARD_SHORTCUT: {
      osx: 'command+/',
      windows: 'ctrl+/',
      linux: 'ctrl+/',
      other: 'ctrl+/'
    },

    DOT: "d",
    LINE: "l g",
    LINE_CATEGORY:'l c',
    PIE: 'p',
    BAR_FREQUENCY: 'b f',
    BAR_VALUE: 'b v',
    BAR_SUM: 'b s',
    BAR_MEAN: 'b m',
    BAR_STRETCHED: 'b t',
    HISTOGRAM: 'h f',
    HISTOGRAM_PROPORTION: 'h r',
    HISTOGRAM_PERCENTAGE: 'h p',
    BOX: 'x p',
    BOX_OUTLIER: 'x o',
    BOX_DOT: 'x d',
    Map: 'm',
    // save for possible future BubbleChart menu; disabled 2025-02-05
    // see BubbleChart in keymap.js, ToolbarComponent.jsx, and ToolbarMenus.js
    // Scatter: 's',
    // BubbleChart: 'b c',
    // Map: 'm p',
    // MapAndBubble: 'm b',
    // MapAndLine: 'm l',

    MEAN: {
      osx: 'command+ctrl+m',
      windows: 'ctrl+shift+m',
      linux: 'ctrl+shift+m',
      other: 'ctrl+shift+m'
    },
    MEDIAN: {
      osx: 'command+ctrl+e',
      windows: 'ctrl+shift+e',
      linux: 'ctrl+shift+e',
      other: 'ctrl+shift+e'
    },
    MODE: {
      osx: 'command+ctrl+o',
      windows: 'ctrl+shift+o',
      linux: 'ctrl+shift+o',
      other: 'ctrl+shift+o'
    },
    MEAN_MODE_DEVIATION: {
      osx: 'command+ctrl+a',
      windows: 'ctrl+shift+a',
      linux: 'ctrl+shift+a',
      other: 'ctrl+shift+a'
    },
    STD_DEVIATION: {
      osx: 'command+ctrl+s',
      windows: 'ctrl+shift+s',
      linux: 'ctrl+shift+s',
      other: 'ctrl+shift+s'
    },
    VARIANCE: {
      osx: 'command+ctrl+v',
      windows: 'ctrl+shift+v',
      linux: 'ctrl+shift+v',
      other: 'ctrl+shift+v'
    },
    IQR: {
      osx: 'command+ctrl+i',
      windows: 'ctrl+shift+i',
      linux: 'ctrl+shift+i',
      other: 'ctrl+shift+i'
    },
    STD_ERROR: {
      osx: 'command+ctrl+r',
      windows: 'ctrl+shift+r',
      linux: 'ctrl+shift+r',
      other: 'ctrl+shift+r'
    },
    LABEL_TOGGLE: {
      osx: 'ctrl+command+l',
      windows: 'ctrl+shift+l',
      linux: 'ctrl+shift+l',
      other: 'ctrl+shift+l'
    },
    DIVIDERS: {
      osx: "command+ctrl+p",
      windows: "ctrl+shift+p",
      linux: "ctrl+shift+p",
      other: "ctrl+shift+p",
    },
    CLEAR_REFERENCE_LINE: {
      osx: "command+\\",
      windows: "ctrl+\\",
      linux: "ctrl+\\",
      other: "ctrl+\\",
    },
    LEAST_SQUARES_LINE: {
      osx: "command+ctrl+u",
      windows: "ctrl+shift+u",
      linux: "ctrl+shift+u",
      other: "ctrl+shift+u",
    },
    SHOW_SQUARES: {
      osx: "command+ctrl+w",
      windows: "ctrl+shift+w",
      linux: "ctrl+shift+w",
      other: "ctrl+shift+w",
    },
    CLEAR_ALL_ANNOTATIONS: {
      osx: "command+a",
      windows: "ctrl+a",
      linux: "ctrl+a",
      other: "ctrl+a",
    },
    SAMPLE_PANEL: {
      osx: 'option+d',
      windows: 'alt+d',
      linux: 'alt+d',
      other: 'alt+d'
    },
    MODEL_PANEL: {
      osx: 'option+f',
      windows: 'alt+f',
      linux: 'alt+f',
      other: 'alt+f'
    },
    ADD_NEW_ATTRIBUTE_PANEL: {
      osx: 'option+a',
      windows: 'alt+a',
      linux: 'alt+a',
      other: 'alt+a'
    },

    TABLEVIEW_FOCUS: {
      osx: 'option+t',
      windows: 'alt+t',
      linux: 'alt+t',
      other: 'alt+t'
    },
    SUMMARYVIEW_FOCUS: {
      osx: 'option+s',
      windows: 'alt+s',
      linux: 'alt+s',
      other: 'alt+s'
    },
    TABLE_FULL_VIEW: {
      osx: 'ctrl+shift+f',
      windows: 'ctrl+shift+f',
      linux: 'ctrl+shift+f',
      other: 'ctrl+shift+f'
    },
    TOOLBAR_FOCUS: 'shift+m',
    CASECARD_FOCUS: 'shift+c',
    PLOTVIEW_FOCUS: 'shift+p',
    TITLE_FOCUS : 'shift+t',
    X_FOCUS: 'shift+x',
    Y_FOCUS: 'shift+y',
    LEGEND_FOCUS: 'shift+l',

    ANNOTATION_FOCUS: {
      osx: 'ctrl+option+a',
      windows: 'ctrl+alt+a',
      linux: 'ctrl+alt+a',
      other: 'ctrl+alt+a'
    },
    COUNT_FOCUS: {
      osx: 'ctrl+option+n',
      windows: 'ctrl+alt+n',
      linux: 'ctrl+alt+n',
      other: 'ctrl+alt+n'
    },
    HELP_FOCUS: {
      osx: 'ctrl+option+h',
      windows: 'ctrl+alt+h',
      linux: 'ctrl+alt+h',
      other: 'ctrl+alt+h'
    },
    FILTER_FOCUS: {
      osx: 'ctrl+option+f',
      windows: 'ctrl+alt+f',
      linux: 'ctrl+alt+f',
      other: 'ctrl+alt+f'
    },
    MODEL_FOCUS: {
      osx: 'ctrl+option+m',
      windows: 'ctrl+alt+m',
      linux: 'ctrl+alt+m',
      other: 'ctrl+alt+m'
    },
    REF_LINES_FOCUS: {
      osx: 'ctrl+option+l',
      windows: 'ctrl+alt+l',
      linux: 'ctrl+alt+l',
      other: 'ctrl+alt+l'
    },
    STATS_FOCUS: {
      osx: 'ctrl+option+s',
      windows: 'ctrl+alt+s',
      linux: 'ctrl+alt+s',
      other: 'ctrl+alt+s'
    },

    ACCESSIBILITY_PANEL: {
      osx: 'option+z',
      windows: 'alt+z',
      linux: 'alt+z',
      other: 'alt+z'
    },
    ACCESSIBILITY_SUPPORT: {
      osx: 'ctrl+command+k',
      windows: 'ctrl+shift+k',
      linux: 'ctrl+shift+k',
      other: 'ctrl+shift+k'
    },
    SEARCH_ATTRIBUTE: {
      osx: 'ctrl+command+a',
      windows: 'ctrl+alt+a',
      linux: 'ctrl+alt+a',
      other: 'ctrl+alt+a'
    },
    DATASET_SUMMARY: "shift+d",
    PLOT_SUMMARY: "shift+s",
    SETTINGS_PANEL: {
      osx: 'option+e',
      windows: 'alt+e',
      linux: 'alt+e',
      other: 'alt+e'
    },

    precision0: {
        osx: 'ctrl+command+0',
        windows: 'ctrl+shift+0',
        linux: 'ctrl+shift+0',
        other: 'ctrl+shift+0'
    },
    // precision6: {
    //   osx: 'ctrl+command+6',
    //   windows: 'ctrl+shift+6',
    //   linux: 'ctrl+shift+6',
    //   other: 'ctrl+shift+6'
    // },
    'precisionDelta-1': {
        osx: 'ctrl+command+1',
        windows: 'ctrl+shift+1',
        linux: 'ctrl+shift+1',
        other: 'ctrl+shift+1'
    },
    'precisionDelta+1': {
        osx: 'ctrl+command+2',
        windows: 'ctrl+shift+2',
        linux: 'ctrl+shift+2',
        other: 'ctrl+shift+2'
    },

  }
}
